export function initStoryGallery() {
    const root = document.querySelector('[data-story-gallery]');

    if (!root) {
        return;
    }

    const cards = Array.from(root.querySelectorAll('[data-story-card]'));
    const filterButtons = Array.from(root.querySelectorAll('[data-story-filter]'));
    const searchInput = root.querySelector('[data-story-search]');
    const results = root.querySelector('[data-story-results]');
    const emptyState = root.querySelector('[data-story-empty]');
    const dialog = root.querySelector('[data-story-dialog]');
    const dialogImage = root.querySelector('[data-story-dialog-image]');
    const dialogTitle = root.querySelector('[data-story-dialog-title]');
    const dialogDescription = root.querySelector('[data-story-dialog-description]');
    const dialogCounter = root.querySelector('[data-story-dialog-counter]');
    const dialogLink = root.querySelector('[data-story-dialog-link]');
    const dialogLinkLabel = root.querySelector('[data-story-dialog-link-label]');
    const loader = root.querySelector('[data-story-loader]');
    const closeButton = root.querySelector('[data-story-close]');
    const previousButton = root.querySelector('[data-story-prev]');
    const nextButton = root.querySelector('[data-story-next]');

    if (!cards.length || !dialog || !dialogImage) {
        return;
    }

    let activeFilter = 'all';
    let visibleCards = [...cards];
    let currentIndex = 0;
    let lastTrigger = null;

    const normalize = (value) => value
        .toLocaleLowerCase('pl')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

    const updateResults = () => {
        const count = visibleCards.length;
        const label = count === 1 ? 'realizacja' : (count > 1 && count < 5 ? 'realizacje' : 'realizacji');

        results.textContent = `${count} ${label}`;
        emptyState.hidden = count !== 0;
    };

    const applyFilters = () => {
        const phrase = normalize(searchInput.value.trim());

        cards.forEach((card) => {
            const matchesCategory = activeFilter === 'all'
                || (activeFilter === 'it' && ['www', 'shops', 'apps'].includes(card.dataset.storyCategory))
                || card.dataset.storyCategory === activeFilter;
            const searchable = normalize(`${card.dataset.storyTitle} ${card.dataset.storyDescription}`);
            const matchesSearch = !phrase || searchable.includes(phrase);

            card.hidden = !(matchesCategory && matchesSearch);
        });

        visibleCards = cards.filter((card) => !card.hidden);
        updateResults();
    };

    const renderDialog = () => {
        const card = visibleCards[currentIndex];

        if (!card) {
            return;
        }

        loader.hidden = false;
        dialogImage.alt = card.dataset.storyTitle;
        dialogImage.src = card.dataset.storyImage;
        dialogTitle.textContent = card.dataset.storyTitle;
        dialogDescription.textContent = card.dataset.storyDescription;
        dialogCounter.textContent = `${currentIndex + 1} / ${visibleCards.length}`;

        if (card.dataset.storyUrl) {
            dialogLink.hidden = false;
            dialogLink.href = card.dataset.storyUrl;
            dialogLinkLabel.textContent = card.dataset.storyLinkLabel || 'Odwiedź stronę';
        } else {
            dialogLink.hidden = true;
            dialogLink.removeAttribute('href');
        }

        const hasMultiple = visibleCards.length > 1;
        previousButton.hidden = !hasMultiple;
        nextButton.hidden = !hasMultiple;
    };

    const openDialog = (card, trigger) => {
        currentIndex = visibleCards.indexOf(card);

        if (currentIndex < 0) {
            return;
        }

        lastTrigger = trigger;
        renderDialog();
        dialog.showModal();
        document.body.classList.add('story-dialog-open');
        closeButton.focus();
    };

    const closeDialog = () => {
        if (dialog.open) {
            dialog.close();
        }
    };

    const moveDialog = (direction) => {
        currentIndex = (currentIndex + direction + visibleCards.length) % visibleCards.length;
        renderDialog();
    };

    filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
            activeFilter = button.dataset.storyFilter;
            filterButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
            applyFilters();
        });
    });

    searchInput.addEventListener('input', applyFilters);

    cards.forEach((card) => {
        const trigger = card.querySelector('[data-story-open]');
        trigger.addEventListener('click', () => openDialog(card, trigger));
    });

    closeButton.addEventListener('click', closeDialog);
    previousButton.addEventListener('click', () => moveDialog(-1));
    nextButton.addEventListener('click', () => moveDialog(1));

    dialogImage.addEventListener('load', () => {
        loader.hidden = true;
    });

    dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
            closeDialog();
        }
    });

    dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeDialog();
    });

    dialog.addEventListener('close', () => {
        document.body.classList.remove('story-dialog-open');
        dialogImage.removeAttribute('src');

        if (lastTrigger) {
            lastTrigger.focus();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (!dialog.open) {
            return;
        }

        if (event.key === 'ArrowLeft') {
            moveDialog(-1);
        }

        if (event.key === 'ArrowRight') {
            moveDialog(1);
        }
    });
}
